import type { HireView } from '@nest-recruit/shared';

type JoiningFacts = Pick<HireView, 'jobStatus' | 'position'>;

/** Bug #58: a job made without a position (D20, F5.24) has no seat, so nothing claims one was filled. */
export function joinedDetail(hire: JoiningFacts): string {
  if (hire.jobStatus === 'filled') return 'That was the last place — the job is filled.';
  return hire.position ? 'Their employee record is made and the seat is filled.' : 'Their employee record is made. This job has no position, so there is no seat to fill.';
}

export function confirmMeta(hire: JoiningFacts): string {
  return hire.position ? 'Makes the employee record, fills the seat and counts the place' : 'Makes the employee record and counts the place';
}
